import { render } from "./QuillToolbar.vue?vue&type=template&id=1282aaaa&scoped=true"
import script from "./QuillToolbar.vue?vue&type=script&lang=js"
export * from "./QuillToolbar.vue?vue&type=script&lang=js"

import "./QuillToolbar.vue?vue&type=style&index=0&id=1282aaaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1282aaaa"]])

export default __exports__